// removed by extract-text-webpack-plugin
module.exports = {"weddingParty":"src-components-WeddingParty----index-module---weddingParty---17318","weddingPartyGroup":"src-components-WeddingParty----index-module---weddingPartyGroup---1jlBF","weddingPartyPerson":"src-components-WeddingParty----index-module---weddingPartyPerson---1etFN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/WeddingParty/index.module.scss
// module id = 75
// module chunks = 104101334113578 114276838955818